import InviteCompanyForm from "./InviteCompanyForm";

export default InviteCompanyForm;
